module.exports = __webpack_public_path__ + "img/132.2.9cff97c0.png";